<template>
  <div class="page_body">
      <div class="data_main">
          <div class="data_group mt18">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="addCard = true" v-if="power.indexOf('1')>=0">创建水卡规格</el-button>
          </div>

          <div class="data_table mt18">
              <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                  <el-table-column prop="titleName" label="水卡名称" min-width="180" align="center"></el-table-column>
                  <el-table-column prop="spec" label="水卡规格" min-width="180" align="center"></el-table-column>
                  <el-table-column prop="goodsNo" label="商品编码" min-width="180" align="center"></el-table-column>
                  <el-table-column prop="deliveryArea" label="销售区域" min-width="180" align="center"></el-table-column>
                  <el-table-column label="图片" min-width="180px" align="center">
                    <template slot-scope="scope">
                      <img :src="imageURL+scope.row.picture" class="picImg">
                    </template>
                  </el-table-column>
                  <el-table-column prop="deliveryType" label="快递方式" min-width="180px" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.deliveryType == 1">自有仓配送</span>
                      <span v-if="scope.row.deliveryType == 2">京东仓配送</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="100" v-if="power.indexOf('2')>=0">
                    <template slot-scope="scope">
                      <el-button type="text" @click="delCard(scope.row.id)">删除</el-button>
                    </template>
                  </el-table-column>
              </el-table>
          </div>
          
          <el-dialog class="popup_dialog" title="新增水卡规格" :visible.sync="addCard" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
            <el-form ref="formData" :model="formData" :rules="rules" label-width="80px" size="small">
                <el-form-item label="水卡名称：" prop="titleName">
                    <el-input v-model="formData.titleName" placeholder="请输入水卡名称"></el-input>
                </el-form-item>
                <el-form-item label="水卡规格：" prop="spec">
                    <el-input v-model="formData.spec" placeholder="请输入水卡规格"></el-input>
                </el-form-item>
                <el-form-item label="商品编码：" prop="goodsNo">
                    <el-input v-model="formData.goodsNo" placeholder="请输入商品编码"></el-input>
                </el-form-item>
                <el-form-item label="包含数量：" prop="packUnit">
                    <el-input v-model.number="formData.packUnit" placeholder="请输入包含数量"></el-input>
                </el-form-item>
                <el-form-item label="销售区域：" prop="deliveryArea">
                  <el-select v-model="formData.deliveryArea" multiple placeholder="请选择">
                    <el-option
                      v-for="item in proList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="图片：" prop="picture">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadURL"
                    ref="uploadEditImg"
                    :before-upload="beforeUploadImageNew"
                    :on-success="portraitUpload"
                    :show-file-list="false"
                  >
                    <img
                      v-if="formData.picture"
                      :src="imageURL + formData.picture"
                      class="avatar"
                    />
                    <el-progress
                      v-else-if="!formData.picture && isUploadShow.picture"
                      type="circle"
                      :percentage="circle.picture"
                      :width="120"
                    ></el-progress>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div class="el-upload__tip">
                    支持扩展名： .jpg .png
                    .jper格式，800*800，最多上传1张，图片大小不超过2M
                  </div>
                </el-form-item>
                <el-form-item label="快递方式：" prop="deliveryType">
                  <el-radio-group v-model="formData.deliveryType" class="">
                      <el-radio :label="1">
                          自有仓配送
                      </el-radio>
                      <el-radio :label="2">
                          京东仓配送
                      </el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="submitFormAdd('formData')">提  交</el-button>
                    <el-button @click="closeAdd">关  闭</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>
        <pagination :size="listQuery.pageSize" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
      </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import {getCard,postCard,delCard,getPro} from '@/api/index'
import {mapState} from "vuex";
export default {
name: "contentArticleIndex",
data () {
  return {
    timer: null,
    isUploadShow: {
      picture: false,
    },
    circle: {
      picture: 0,
    },
    imageURL: window.config.imageURL,
    uploadURL: window.config.uploadURL,
    listQuery: {
      page: 1,
      pageSize: 10
    },
    pages: {
      total: 0,
      pages: 0
    },
    options:[],
    formData:{
      titleName:'',
      spec:'',
      goodsNo:'',
      packUnit:0,
      deliveryArea:[],
      deliveryType:1,
      picture:''
    },
    rules: {
      spec: [
        {required: true, message: '请输入水卡规格', trigger: 'blur'}
      ],
      goodsNo:[
        {required: true, message: '请输入商品编码', trigger: 'blur'}
      ],
      deliveryType:[
        {required: true, message: '请选择方式', trigger: 'change'}
      ],
      picture:[
        {required: true, message: '请上传图片', trigger: 'change'}
      ],
      deliveryArea: [
        {required: true, message: '请添加水卡范围', trigger: 'blur'}
      ],
    },
    addCard:false,
    isSubmitLoading: false,
    isSearchLoading: false,
    isRequestLoading: false,
    listData: [],
    proList:[],
    power:null
  }
},
computed: {
  ...mapState({
    listKeepAlive: state => state.app.listKeepAlive,
  })
},
activated () {
  this.getPro()
  this.getCard()
},
created(){
  this.power = JSON.parse(localStorage.getItem('userRole')).power[1]
},
methods: {
  getPro(){
    getPro().then(res=>{
      this.proList = res.data
    })
  },
  proUp(name) {
    let that = this;
    if (this.circle[name] < 50) {
      this.timer = setTimeout(() => {
        that.circle[name] = 50;
        that.proUp(name);
      }, 300);
    } else if (this.circle[name] < 100) {
      this.timer = setTimeout(() => {
        that.circle[name] = 99;
      }, 300);
    }
  },
  beforeUploadImageNew(file) {
    // console.log(file)
    if (!this.beforeUploadImage(file)) {
      return false;
    }
    this.formData.picture = null;
    this.isUploadShow.picture = true;
    this.circle.picture = 0;
    this.proUp("picture");
  },
  portraitUpload(res) {
    clearTimeout(this.timer);
    this.circle.picture = 100;
    if (res.code === 0) {
      this.formData.picture = res.data;
      this.isUploadShow.picture = false;
      this.circle.picture = 0;
    } else {
      this.formData.picture = "";
      this.isUploadShow.picture = false;
      this.circle.picture = 0;
    }
  },
  beforeUploadImage(file) {
    if (file.size > 1024 * 1024 * 2) {
      this.$message({
        message: "请上传大小不超过2M的图片",
        type: "warning",
        duration: 2 * 1000,
        showClose: true,
      });
      return false;
    }
    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      this.$message({
        message: "请上传.jpg、.jpeg、.png格式的图片",
        type: "warning",
        duration: 2 * 1000,
        showClose: true,
      });
      return false;
    }
    return true;
  },
  submitFormAdd (formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        this.isSubmitLoading = true
        this.formData.deliveryArea = this.formData.deliveryArea.join(',')
        postCard({
          data: this.formData
        }).then(res => {
          this.isSubmitLoading = false
          if (res.code == 0) {
            this.$message({
              message: '水卡规格新增成功',
              type: 'success',
              showClose: true,
            });
            
            this.formData= {
              titleName:'',
              spec:'',
              goodsNo:'',
              packUnit:0,
              deliveryArea:[],
              deliveryType:1,
              picture:''
            },
            this.addCard = false
            this.listQuery.page = 1
            this.getCard()
          } else {
            this.formData.deliveryArea = this.formData.deliveryArea.split(',')
          }
        }).catch(() => {
          this.isSubmitLoading = false
        })
      }
    })
  },
  closeAdd(){
    this.formData= {
      titleName:'',
      spec:'',
      goodsNo:'',
      packUnit:0,
      deliveryArea:[],
      deliveryType:1,
      picture:''
    },
    this.addCard = false
  },
  delCard (id) {
    this.$confirm('此操作将永久删除该水卡, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning'
    }).then(() => {
      delCard(id).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '水卡删除成功',
            type: 'success',
            showClose: true,
          });
          this.getCard()
        }
      })
    }).catch(() => {});
  },
  pageChange (e) {
    this.listQuery.page = e.current
    this.listQuery.pageSize = e.size
    this.getCard()
  },
  getCard(){
    getCard(this.listQuery).then(res=>{
      console.log(res)
      this.listData = res.data.records
      this.pages.total = res.data.total
      this.pages.pages = res.data.pages
    })
  },
},
components: {
  pagination
}
}
</script>
<style lang="scss" scoped>
.picImg{
  max-width: 120px;
}
</style>